import "./_form-page.scss";
import React from 'react';

interface FormPageProps extends React.PropsWithChildren<any> {
    title: string;
    subText?: string;
}

function FormPage({title, subText, children}: Readonly<FormPageProps>) {
    return (
        <div className="form-page">
            <div className="form-page-header">
                <h1>{title}</h1>
                {subText && <h6>{subText}</h6>}
            </div>
            <div className="form-page-body" aria-label="Distributions">
                {children}
            </div>
        </div>
    );
}

export default FormPage;